import { PaletteMode, SimplePaletteColorOptions } from '@mui/material';
import { successColor } from './status/success';

export const success = (mode: PaletteMode): SimplePaletteColorOptions => {
  const color = successColor(mode);
  return {
    main: color.main,
    light: mode === 'light' ? color.lowContrast : color.highContrast,
    dark: mode === 'light' ? color.highContrast : color.lowContrast,
  };
};
